// Central config for the footer info pages.
// Each entry drives both a footer link and a generated InfoPage route.

const footerPages = [
  {
    slug: 'terms-and-conditions',
    title: 'Terms and Conditions / Consent',
    note:
      'Basic consent tracking fields already exist, so only the following enhancements are needed. Consent content is reviewed alongside the other parent consent forms.',
    points: [
      'Terms & Conditions content management',
      'Consent checkbox in outsider registration form',
      'Versioning of consent text',
      'Mapping consent acceptance with existing user audit data',
    ],
  },
  {
    slug: 'payment-gateway',
    title: 'Payment Gateway',
    note:
      'Applicable only for outsiders, not for existing parents. Identity documents are collected and authenticated for outsiders.',
    points: [
      'Membership fee / deposit / fine payment',
      'Payment success / failure flow',
      'Transaction record',
      'Receipt generation',
    ],
  },
  {
    slug: 'refund-process',
    title: 'Refund Process',
    note: 'Refunds apply only for outsiders, not for existing parents.',
    points: [
      'Refund request',
      'Admin approval / rejection',
      'Refund status tracking',
      'Refundable amount calculation after fine adjustment',
    ],
  },
  {
    slug: 'fine-calculation',
    title: 'Fine Calculation Based on Book Return',
    note:
      'For existing parents (who pay no security deposit), the recovery amount can be handled via a clause in the consent form, subject to confirmation from accounts.',
    points: [
      'Overdue fine',
      'Damage fine',
      'Lost book charge',
      'Refundable amount after deduction',
    ],
  },
  {
    slug: 'receipt-generation',
    title: 'Receipt Generation',
    note: 'Library cards are generated for outsiders after successful payment.',
    points: [
      'Payment receipt PDF',
      'Receipt number',
      'Send receipt by email / SMS if required',
    ],
  },
  {
    slug: 'student-parent-import',
    title: 'Existing Student / Parent Import',
    note: 'Bring existing records into the system and make them usable for the issue/return flow.',
    points: [
      'Import existing students and parents from Excel / CSV',
      'Map them for issue / return flow',
      'Search by name, mobile, admission no, parent name',
    ],
  },
  {
    slug: 'issue-return-flow',
    title: 'Existing User Issue / Return Flow',
    note:
      'Auto reminders are sent for the book return due date, with a maximum number of books that can be issued to one person at a time.',
    points: [
      'Issue books to imported users',
      'Return books',
      'Auto-calculate fines',
      'Show pending fine before next issue',
    ],
  },
  {
    slug: 'privacy-policy',
    title: 'Privacy Policy',
    note:
      'How the Jaipuria Community Library Center collects, uses, and protects your personal information.',
    points: [
      'Information we collect',
      'How we use your information',
      'Data storage and security',
      'Your rights and choices',
    ],
  },
  {
    slug: 'faqs',
    title: 'Frequently Asked Questions',
    note: 'Answers to the most common questions about library membership and usage.',
    points: [
      'Who can register at the community library?',
      'How do I issue and return books?',
      'How are fines calculated?',
      'How do membership fees and refunds work?',
    ],
  },
];

export default footerPages;
